import {
  SearchSuggestionType,
  LinkTrackingData,
} from '../../../../../AnalyticsContext/LinkTracking';
import { Person } from '../../../../icons/outlined/Person';
import {
  SuggestionIcon,
  SuggestionPrimary,
  SuggestionSecondary,
} from '../SuggestionStyles/SuggestionStyles.styles';
import { SuggestionTemplate } from '../SuggestionTemplate/SuggestionTemplate';
import { SuggestionImage } from './SuggestionImage/SuggestionImage';

export const PractitionerSuggestion = ({
  title,
  firstName,
  lastName,
  specialties,
  suburb,
  state,
  imagePath,
  trackingData,
}: {
  title?: string;
  firstName?: string;
  lastName?: string;
  specialties: string[];
  suburb?: string;
  state?: string;
  imagePath?: string;
  trackingData: LinkTrackingData;
}) => (
  <SuggestionTemplate
    trackingData={{ ...trackingData, searchSuggestionType: SearchSuggestionType.PRACTITIONER }}
    visual={
      (imagePath && <SuggestionImage imagePath={imagePath} />) || (
        <SuggestionIcon>
          <Person />
        </SuggestionIcon>
      )
    }
    primary={
      <SuggestionPrimary>
        {[title, firstName, lastName].filter(Boolean).join(' ')}
      </SuggestionPrimary>
    }
    secondary={
      <SuggestionSecondary>
        {specialties.join(', ')}
        {(specialties.length && (suburb || state) && ' - ') || ''}
        {[suburb, state].filter(Boolean).join(' ')}
      </SuggestionSecondary>
    }
  />
);
